import React from 'react'
import { Col, Row } from 'react-bootstrap'
import Chart from 'react-google-charts'
import { PulseLoader } from 'react-spinners'

const AbnormalMotionEventGraph = ({heartRateData, eventData, loading, data}) => {

  const options = {
    title: "Motion Monitoring Amplitude",
    width: "100%",
    height: 500,
    legend: "bottom",
    series: !!heartRateData?.length
      ? {
          0: { targetAxisIndex: 0, type: "line", axis: "MotionMonitoring" },
          1: { targetAxisIndex: 1, type: "scatter", axis: "HeartRate" },
        }
      : {
          0: { targetAxisIndex: 0, type: "line", axis: "MotionMonitoring" },
        },
    axes: {
      y: !!heartRateData?.length
        ? {
          MotionMonitoring: { label: "Motion Monitoring" },
            HeartRate: { label: "Heart Rate" },
          }
        : { MotionMonitoring: { label: "Motion Monitoring" } },
    },
      vAxes:!!heartRateData?.length?{    
        0: {title: 'Motion Monitoring' ,format:'0'},
        1: {title: 'Heart Rate',format:'0', minValue: heartRateData[0].y-5, 
        maxValue: heartRateData[heartRateData?.length-1].y+5}}:{0: {title: 'Motion Monitoring'}},
    hAxis: {
      title: "Motion Monitoring Duration ( In Secs )",
      format:'0'
    },
    colors: ["#5CB3FF", "#E42217"],
  };
  return (
    <>
        
        {((heartRateData && eventData?.sensorData?.formattedData) !== null ? (
          <Row className="chart-container" style={{position:'relative'}}>
           {loading && <div className="pulse-loader-container inside-graph"><PulseLoader
                  color={"#70757a"}
                  loading={loading}
                  aria-label="Loading Spinner"
                  data-testid="loader"
                /></div>} 
          <Col>
            <Chart
              chartType="ComboChart"
              width="100%"
              height="500px"
              data={data}
              id="DualEventGraph"
              options={options}
              style={{ padding: "0" }}
            />
          </Col>
        </Row>
      ) : (
        <div style={{ padding: "16px" }}>
          {" "}
          Motion Monitoring and Heart rate Data Unavailable{" "}
        </div>
      ))}
    </>
  )
}

export default AbnormalMotionEventGraph